'use client'

import { FC } from 'react'
import NextError from 'next/error'

type Props = {
  error: Error & { digest?: string }
  reset: () => void
}

const GlobalError: FC<Props> = ({ error }) => {
  return (
    <html>
      <body>
        <NextError statusCode={0} title={error.message} />
      </body>
    </html>
  )
}

export default GlobalError
